import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "permitions-tab" }
const _hoisted_2 = { class: "permitions-tab__field permitions-tab__field--col" }
const _hoisted_3 = {
  key: 0,
  class: "permitions-tab__field permitions-tab__field--col"
}
const _hoisted_4 = { class: "permitions-tab__field-name" }
const _hoisted_5 = { class: "permitions-tab__field-value-col-time" }
const _hoisted_6 = { class: "permitions-tab__field-value-col-name" }
const _hoisted_7 = { class: "permitions-tab__field-value-col-action" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "permitions-tab__actions" }

import AppSelect from "@/components/ui-kit/select/AppSelect.vue";
import UserGroupDropdownContent from "@/components/permitions/UserGroupDropdownContent.vue";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import FilePermitionsUserGroupList from "./FilePermitionsUserGroupList.vue";
import { computed, onMounted, ref, watch } from "vue";
import type { SelectOption } from "../../ui-kit/select/AppSelect.vue";
import moment from "moment";
import { FileApi } from "@/ api/FileApi";
import { WorkersAndAccessGroupsInSettingsGiver } from "@/models/interfaces/access/entity-rules";
import { AccessApi } from "@/ api/AccessApi";
import { workerStore } from "@/store/worker";
import { i18n } from "@/i18n";
import { formatChangelogText } from "@/utils/textHelpers";

type Props = {
  fileInfo?: any;
  ruleAccess: number;
  entityId: number;
  clientId: number;
  projectId: number;
  isFolder?: boolean;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'FilePermitionsTab',
  props: {
    fileInfo: {},
    ruleAccess: { default: 0 },
    entityId: {},
    clientId: {},
    projectId: {},
    isFolder: { type: Boolean, default: false }
  },
  emits: ["save", "openDropdown", "closeDropdown"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const groupsRules = ref<WorkersAndAccessGroupsInSettingsGiver>();
const initialGroups = ref<(string | number)[]>([]);
const currentWorkerStore = workerStore();
const dropdownLabel = computed(() => {
  return String(i18n.global.t("permissions_selected_users", {
    count: selectedDisplayList.value.length,
  }));
});

const selectedPerson = ref<(string | number)[]>([]);
const hasFakeCurrentWorker = ref(false);
const showAllChanges = ref(false);
const isSaving = ref(false);

onMounted(async () => {
  groupsRules.value = await AccessApi.getWorkersAndAccessGroups();
});

const openDropdown = () => {
  emit("openDropdown");
};

const closeDropdown = () => {
  emit("closeDropdown");
};

watch(
  () => props.fileInfo,
  (newVal) => {
    const ids = newVal?.GroupsWithAccess?.length
      ? newVal.GroupsWithAccess.map((g: any) => g.Id)
      : [];
    selectedPerson.value = ids;
    initialGroups.value = [...ids];
    hasFakeCurrentWorker.value = false;
  },
  { immediate: true },
);

const hasChanges = computed(() => {
  if (selectedPerson.value.length !== initialGroups.value.length) return true;
  const initialSet = new Set(initialGroups.value);
  return selectedPerson.value.some((id) => !initialSet.has(id));
});

const currentWorkerGroupId = computed<number | null>(() => {
  const workerId = currentWorkerStore.workerProfile?.Id;
  if (!workerId) return null;

  for (const holder of groupsRules.value?.Holders ?? []) {
    if (holder.IsWorker && holder.Worker?.Id === workerId) {
      return holder.Worker.GroupId;
    }

    const worker = holder.Departament?.Workers?.find(
      (item) => item.Id === workerId,
    );
    if (worker) return worker.GroupId;
  }

  return null;
});

const updateSelected = (newSelected: (string | number)[]) => {
  const nextSelected = [...new Set(newSelected)];
  const workerGroupId = currentWorkerGroupId.value;
  const addsFirstGroupAfterClear =
    selectedPerson.value.length === 0 && nextSelected.length > 0;

  if (workerGroupId === null) {
    selectedPerson.value = nextSelected;
    return;
  }

  const selectedWithoutCurrentWorker = nextSelected.filter(
    (id) => id !== workerGroupId,
  );

  if (hasFakeCurrentWorker.value && selectedWithoutCurrentWorker.length === 0) {
    selectedPerson.value = [];
    hasFakeCurrentWorker.value = false;
    return;
  }

  if (hasFakeCurrentWorker.value && !nextSelected.includes(workerGroupId)) {
    nextSelected.unshift(workerGroupId);
  } else if (
    (!initialGroups.value.includes(workerGroupId) ||
      addsFirstGroupAfterClear) &&
    nextSelected.length > 0 &&
    !nextSelected.includes(workerGroupId)
  ) {
    nextSelected.unshift(workerGroupId);
    hasFakeCurrentWorker.value = true;
  }

  selectedPerson.value = nextSelected;
};

const save = async () => {
  if (isSaving.value) return;
  if (!hasChanges.value) {
    emit("save");
    return;
  }

  isSaving.value = true;
  try {
    const groupIds = selectedPerson.value as number[];

    if (props.isFolder) {
      await FileApi.EditFolderAccess(
        props.entityId,
        groupIds,
        props.clientId,
        props.projectId,
      );
    } else {
      await FileApi.EditFileAccess(
        props.entityId,
        groupIds,
        props.clientId,
        props.projectId,
      );
    }

    initialGroups.value = [...selectedPerson.value];
    hasFakeCurrentWorker.value = false;
    emit("save");
  } catch (e) {
    console.error(e);
  } finally {
    isSaving.value = false;
  }
};

const optionsPersons = computed<SelectOption[]>(() => {
  if (!groupsRules.value?.Holders.length) return [];

  const groups: SelectOption[] = [];
  const workersWithoutDepartment: {
    id: number;
    label: string;
    type: "item";
  }[] = [];

  groupsRules.value?.Holders.forEach((el, index) => {
    if (el.Departament) {
      groups.push({
        id: index + 999999,
        label: el.Departament.Name,
        type: "group" as const,
        selectable: true,
        children:
          el.Departament.Workers?.map((worker) => ({
            id: worker.GroupId,
            label: worker.Name,
            type: "item" as const,
          })) ?? [],
      });
    } else if (el.IsWorker && el.Worker) {
      workersWithoutDepartment.push({
        id: el.Worker.GroupId,
        label: el.Worker.Name,
        type: "item" as const,
      });
    }
  });

  groupsRules.value?.Groups.forEach((el, index) => {
    if (!el.IsPersonal) {
      groups.push({
        id: el.Id,
        label: el.Name,
        type: "group" as const,
        selectable: true,
        children: [],
      });
    }
  });

  if (workersWithoutDepartment.length > 0) {
    groups.push({
      id: -1,
      label: String(i18n.global.t("permissions_no_department")),
      type: "group" as const,
      selectable: false,
      children: workersWithoutDepartment,
    });
  }

  return groups;
});

const selectedDisplayList = computed(() => {
  const protectedWorkerGroupId = hasFakeCurrentWorker.value
    ? currentWorkerGroupId.value
    : null;

  const selectedGroups = selectedPerson.value
    .map((id) => {
      for (const item of optionsPersons.value) {
        if (item.type === "group" && "children" in item && item.children) {
          const child = item.children.find((child) => child.id === id);
          if (child) {
            return {
              Id: child.id,
              Name: child.label,
              type: "item",
              CanRemove: child.id !== protectedWorkerGroupId,
            };
          }
        }
        if (item.id === id) {
          return {
            Id: item.id,
            Name: item.label,
            type: item.type,
            CanRemove: item.id !== protectedWorkerGroupId,
          };
        }
      }

      const fromServer = props.fileInfo?.GroupsWithAccess?.find(
        (g: any) => g.Id === id,
      );
      if (fromServer) {
        return {
          Id: fromServer.Id,
          Name: fromServer.Name,
          type: "item",
          CanRemove: fromServer.Id !== protectedWorkerGroupId,
        };
      }

      return null;
    })
    .filter(Boolean) as {
    Id: string | number;
    Name: string;
    type: string;
    CanRemove: boolean;
  }[];

  return selectedGroups;
});

const handleRemoveSelected = (item: {
  Id: string | number;
  Name: string;
  type: string;
}) => {
  updateSelected(selectedPerson.value.filter((id) => id !== item.Id));
};

const getDate = (date: string) => {
  return moment(date).format("HH:mm DD.MM.YYYY");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(AppSelect, {
          modelValue: selectedPerson.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPerson).value = $event)),
          class: "permitions-tab__dropdown",
          "dropdown-class": "select-dropdown--choice-rules-modal select-dropdown--file-permissions",
          placeholder: _ctx.$t('permissions_select_users'),
          items: optionsPersons.value,
          "min-dropdown-width": 665,
          "dropdown-height": 600,
          disabled: _ctx.ruleAccess == 2 ? false : true,
          searchable: "",
          "show-search-button": false,
          multiple: "",
          "show-dropdown-close": "",
          "disabled-icon": "lock",
          "dropdown-close-width": "20px",
          onOpen: openDropdown,
          onClose: closeDropdown,
          "dropdown-label": dropdownLabel.value
        }, {
          dropdown: _withCtx(({ items, selected, select, getGroupState, search }) => [
            _createVNode(UserGroupDropdownContent, {
              items: items,
              selected: selected,
              select: select,
              "get-group-state": getGroupState,
              updateSelected: updateSelected,
              search: search
            }, null, 8, ["items", "selected", "select", "get-group-state", "search"])
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "items", "disabled", "dropdown-label"]),
        (selectedDisplayList.value.length !== 0)
          ? (_openBlock(), _createBlock(FilePermitionsUserGroupList, {
              key: 0,
              groups: selectedDisplayList.value,
              disabled: _ctx.ruleAccess !== 2,
              onRemove: handleRemoveSelected
            }, null, 8, ["groups", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.fileInfo?.Changelog?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("permissions_changed")) + ":", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showAllChanges.value
          ? _ctx.fileInfo.Changelog
          : _ctx.fileInfo.Changelog.slice(0, 4), (change, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "permitions-tab__field-value-col",
                key: change.Time
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(getDate(change.Time)) + " ", 1),
                _createElementVNode("span", _hoisted_6, "[" + _toDisplayString(change.Changer) + "]", 1),
                _createElementVNode("span", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formatChangelogText)(change.Text), (segment, segmentIndex) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: segmentIndex }, [
                      (segment.italic)
                        ? (_openBlock(), _createElementBlock("em", _hoisted_8, _toDisplayString(segment.text), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(segment.text), 1))
                    ], 64))
                  }), 128))
                ]),
                (!showAllChanges.value && _ctx.fileInfo.Changelog.length > 4 && index === 3)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "permitions-tab__field-value-col-show-more",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (showAllChanges.value = true))
                    }, _toDisplayString(_ctx.$t("permissions_more")) + " " + _toDisplayString(_ctx.fileInfo.Changelog.length - 4), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "permitions-tab__line" }, null, -1)),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(AppButton, {
        type: "primary",
        label: _ctx.$t('save'),
        onClick: save,
        disabled: !hasChanges.value || isSaving.value
      }, null, 8, ["label", "disabled"])
    ])
  ], 64))
}
}

})